export const setDateFrom = () => {

    let today = new Date();

    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Se agrega 1 al mes ya que en JavaScript los meses van de 0 a 11.
    let day = String(today.getDate()-1).padStart(2, '0');

    return  `${year}-${month}-${day}`;

};

export default {
    loading:{
        module : false,
    },
    params: {
        date : setDateFrom() ,
        branch_office_id : null,
    },
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    reportData:[],
    branch_offices:[],
    formAlokstosResponse: null,
    formAlokstosProccessResponse: null,
    show_pdf :false,
    file_name :null,
}



// WEBPACK FOOTER //
// ./src/modules/portfolio_reclassification/state.js